// src/pages/Sanitary/SanitaryHistoryModal.js

import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

function SanitaryHistoryModal({ show, handleClose, reportId }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (show && reportId) {
      const fetchHistory = async () => {
        setLoading(true);
        try {
          const response = await axios.post(
            `${API_URL}/sanitary-history.php`,
            { sanitary_id: reportId },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          if (response.data.success && Array.isArray(response.data.history)) {
            setHistory(response.data.history);
          } else {
            setHistory([]);
            toast.info(response.data.message || "No history found.");
          }
        } catch (error) {
          toast.error("Failed to fetch history.");
          setHistory([]);
        } finally {
          setLoading(false);
        }
      };
      fetchHistory();
    }
  }, [show, reportId, API_URL, token]);

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Processing History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : history.length > 0 ? (
          <Table striped bordered hover responsive="sm">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Status</th>
                <th>Action By</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {history.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.action_date}</td>
                  <td>{item.status}</td>
                  <td>{item.action_by_user}</td>
                  <td>{item.remarks}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p className="text-center text-muted">
            No history records found for this report.
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SanitaryHistoryModal;
